import { PerformanceDetailPage } from "@/features/dashboard/pages/PerformanceDetail";

const PerformanceDetail = () => {
  return <PerformanceDetailPage />;
};

export default PerformanceDetail;
